// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, catchError, map, mergeMap, of, toArray } from 'rxjs';

enum ConnectionStatus {
    Pending,
    Success,
    Failed,
    InProgress,
}

type Domain = {
    status: ConnectionStatus;
    label: string;
    testUri: string;
    testResponseType: 'json' | 'text';
};

@Component({
    selector: 'app-network-test-modal',
    templateUrl: './network-test-modal.component.html',
    styleUrls: ['./network-test-modal.component.scss'],
})
export class NetworkTestModalComponent implements OnInit {
    domains: Domain[] = [
        // domains to test
        { label: 'ezdocs123.com', testUri: 'https://ezdocs123.com/', testResponseType: 'text', status: ConnectionStatus.Pending },
        { label: 'digitaldealjacket.com', testUri: 'https://digitaldealjacket.com/', testResponseType: 'text', status: ConnectionStatus.Pending },
        // checks the api
        { label: 'digitaldealjacket.net', testUri: 'https://api.digitaldealjacket.net/health', testResponseType: 'json', status: ConnectionStatus.Pending },
    ];
    ConnectionStatus = ConnectionStatus;

    constructor(
        private readonly dialogRef: MatDialogRef<NetworkTestModalComponent>,
        private readonly http: HttpClient
    ) {}

    ngOnInit(): void {
        of(...this.domains)
            .pipe(
                mergeMap((domain) => this.testDomain(domain)),
                toArray()
            )
            .subscribe();
    }

    testDomain(domain: Domain): Observable<boolean> {
        domain.status = ConnectionStatus.InProgress;
        const options: any = { responseType: domain.testResponseType, observe: 'response' };
        return this.http.head(domain.testUri, options).pipe(
            map((response: any /*HttpResponseBase*/) => {
                const ok = response?.ok ?? false;
                domain.status = ok ? ConnectionStatus.Success : ConnectionStatus.Failed;
                return ok;
            }),
            catchError((resp) => {
                console.error(resp);
                domain.status = ConnectionStatus.Failed;
                return of(false);
            })
        );
    }

    @HostListener('window:keyup.Enter', ['$event'])
    onDialogClick(event: KeyboardEvent): void {
        this.close();
    }

    close() {
        this.dialogRef.close();
    }
}
